module.exports = __webpack_public_path__ + "img/hamb-menu-mobile.89f046b5.svg";